import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SearchCommandInputPlaceholderProps = {
  className?: string;
  placeholder: string;
};

export const SearchCommandInputPlaceholder = memo(({ className, placeholder }: SearchCommandInputPlaceholderProps) => (
  <span
    className={cn(
      'pointer-events-none absolute top-1/2 right-10 -translate-y-1/2 truncate font-medium text-14 text-gray-9',
      className,
    )}
  >
    {placeholder}
  </span>
));

SearchCommandInputPlaceholder.displayName = 'SearchCommandInputPlaceholder';
